'use client'
import * as React from 'react'

type MobileDropdownView = {
  type: 'assets' | 'machines' | 'materials' | 'themes'
} | null

export interface CreatePostProjectDialogContextModel {
  isOpen: boolean
  openDialog: () => void
  closeDialog: () => void
  redirectTo?: string

  mobileView: MobileDropdownView
  openMobileView: (view: NonNullable<MobileDropdownView>) => void
  closeMobileView: () => void
}

const CreatePostProjectDialogContext = React.createContext<CreatePostProjectDialogContextModel>(
  null!,
)

export const CreatePostProjectDialogProvider = ({ children }: React.PropsWithChildren) => {
  const [isOpen, setIsOpen] = React.useState(false)
  const [redirectTo, setRedirectTo] = React.useState<string | undefined>()
  const [mobileView, setMobileView] = React.useState<MobileDropdownView>(null)

  const openDialog = () => {
    setIsOpen(true)
  }

  const closeDialog = () => {
    setIsOpen(false)
    setMobileView(null)
    setRedirectTo(undefined)
  }

  const openMobileView = (view: NonNullable<MobileDropdownView>) => {
    setMobileView(view)
  }

  const closeMobileView = () => {
    setMobileView(null)
  }

  return (
    <CreatePostProjectDialogContext.Provider
      value={{
        isOpen,
        openDialog,
        closeDialog,
        redirectTo,
        mobileView,
        openMobileView,
        closeMobileView,
      }}
    >
      {children}
    </CreatePostProjectDialogContext.Provider>
  )
}

export const useCreatePostProjectDialog = () => {
  const context = React.useContext(CreatePostProjectDialogContext)

  if (context === undefined) {
    throw new Error(
      'useCreatePostProjectDialog must be used within a CreatePostProjectDialogProvider',
    )
  }

  return context
}
